import { render, staticRenderFns } from "./Destacados.vue?vue&type=template&id=699ea198&"
import script from "./Destacados.vue?vue&type=script&lang=js&"
export * from "./Destacados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports